import React, { useEffect, useState } from "react";
import { Col, Form, Row, Button, Input, InputNumber, Descriptions, Card, notification, Tooltip, Select } from "antd";
import { SearchOutlined, BarcodeOutlined, PlusOutlined, CloseOutlined } from "@ant-design/icons";

import api from "../../services/api";
import {  InputPreco, InputPercentual, SelectProduto, SelectPaginacao, SelectPaginado  } from "../../components";
import {  ModalListaProduto, ModalManutencaoNota } from "../modals";
import { useStateValue } from "../../state";
import { manutencaoActions} from "../../actions";
import { isObjetoDiffVazio } from "../../services/funcoes";

export default function FiltroProdutoPdi({ form, dadosTabela, dadosEndereco = {}, custo = {}, dadosOperacao = {} }) {

    
    const [dadosDetalhes, setDadosDetalhes] = useState({});
    const [consultaProduto, setConsultaProduto] = useState(null);
    const [{ manutencao, listaSelectPaginacao }, dispatch] = useStateValue();
    const [dadosContribuinte, setDadosContribuinte] = useState({});
    const [aux, setAux] = useState(false);
    const [dadosProduto, setDadosProduto] = useState({});
    const [abrirModalListaProd, setAbrirModalListaProd] = useState(false);
    const [listaDadosProdModal, setListaDadosProdModal] = useState([]);
    const [abrirModalManutencaoNota, setAbrirModalManutencaoNota] = useState(false);
    const [liberadoParaIncluir, setLiberadoParaIncluir] = useState(false);
    const [produtoBuscaEan, setProdutoBuscaEan] = useState({});
    const [listaSelectProd, setListaSelectProd] = useState([]);
    const [desabilitarProd_id, setDesabilitarProd_id] = useState(false);
    const [exibirDetalhes, setExibirDetalhes] = useState(false);
    const togglePesquisa = () => {
        setConsultaProduto(!consultaProduto);
    };

    useEffect(() => {
        if (!!dadosProduto && isObjetoDiffVazio(dadosProduto)) {
            abrirModalManutencaoProd();
        }
    }, [dadosProduto]);

    useEffect(() => {
        popularDadosContribuintes();
    }, []);

    useEffect(() => {
        if (!!dadosDetalhes && !!liberadoParaIncluir && !!form.getFieldValue().pro_codigo) {
            adicionarItemCodBarras();
            setLiberadoParaIncluir(false);
            form.setFieldsValue({ pro_codigo: null });
        }
    }, [dadosDetalhes, liberadoParaIncluir]);

    useEffect(() => {
        if (!!manutencao.dados) {
            popularDadosContribuintes();

            //popularProduto();
            setAux(true);//criado para carregar os dadosContribuintes antes de entrar no popularProduto
        }
    }, [manutencao.dados]);

    useEffect(() => {
        if (!!listaSelectProd && manutencao.dados?.editando) {
            let dados = { ...manutencao.dados };
            popularProduto(dados.pro_id, true, dados.prg_id);
            dados.pro_id = form.getFieldValue().pro_id;
            form.setFieldsValue(dados);
        }
    }, [listaSelectProd]);

    useEffect(() => {
        if (!!dadosContribuinte && dadosContribuinte.length > 0 && aux && !!manutencao.dados && !!manutencao.dados.pro_id) {
            popularProduto(manutencao.dados.pro_id, true, manutencao.dados.prg_id);
        }
    }, [dadosContribuinte]);

    function abrirModalManutencaoProd() {
        if (isObjetoDiffVazio(custo)) {//validacao da nota de transferencia
            if (!!!dadosProduto.icm_id || !!!dadosProduto.ncm_id || !!!dadosProduto.ump_id || !!!dadosProduto.pro_descricao) {
                setAbrirModalManutencaoNota(true);
            } else if (!!!dadosProduto.iod_ufdestino) {
                setAbrirModalManutencaoNota(true);
            }
        } else {
            if (dadosContribuinte.emp_regimetributario === 3 && (!!!dadosProduto.icm_id || !!!dadosProduto.ncm_id || !!!dadosProduto.ump_id ||
                !!!dadosProduto.pro_descricao || !!!dadosProduto.pis_id || !!!dadosProduto.iod_ufdestino)) {
                setAbrirModalManutencaoNota(true);
            } else if (dadosContribuinte.emp_regimetributario !== 3 && (!!!dadosProduto.icm_id || !!!dadosProduto.ncm_id || !!!dadosProduto.ump_id)) {
                setAbrirModalManutencaoNota(true);
            } else if (!!dadosProduto.cst_id && !!!dadosProduto.mva_ufdestino && (dadosProduto.cst_id === '10' || dadosProduto.cst_id === '30' || dadosProduto.cst_id === '70')) {
                setAbrirModalManutencaoNota(true);
            }
        }
    };

    function popularDadosContribuintes(callback) {
        api.get(`dadosContribuinte/Buscar`).then(
            (res) => {
                if (res.status === 200) {
                    setDadosContribuinte(res.data);
                    if (callback) {
                        callback();
                    }
                }
            }
        ).catch(
            (erro) => {
                console.log(erro);
            }
        );
    };

    function alterarValorTotal() {
        let total = 0;

        total = form.getFieldValue().pdi_quantidade * form.getFieldValue().pdi_valorunitario;
        form.setFieldsValue({ pdi_valortotal: total.toFixed(2) });

        calculaDesconto('ATT');
    };

    function calculaTotalItemDescAcr() {
        let valorTot = 0;
        let valorItens = !!form.getFieldValue().pdi_valortotal ? form.getFieldValue().pdi_valortotal : 0;
        let valorAcrescimo = !!form.getFieldValue().acrescimo ? form.getFieldValue().acrescimo : 0;
        let valorDesc = !!form.getFieldValue().desconto ? form.getFieldValue().desconto : 0;
        valorTot = parseFloat(valorItens) + parseFloat(valorAcrescimo) - parseFloat(valorDesc);
        form.setFieldsValue({ valorItemDesconto: valorTot.toFixed(2) });
    };

    function calculaDesconto(campo) {
        let valor = (!!form.getFieldValue().desconto ? form.getFieldValue().desconto : 0);
        let perc = (!!form.getFieldValue().percdesc ? form.getFieldValue().percdesc : 0);
        let tot = parseFloat(form.getFieldValue().pdi_valortotal);
        let result = 0;
        if (!!campo) {
            if (campo === 'PERC') {
                result = (tot * perc) / 100;
                form.setFieldsValue({ desconto: result.toFixed(2) });
            } else if (campo === 'ATT') {
                result = (tot * perc) / 100;
                form.setFieldsValue({ desconto: result.toFixed(2) });
                valor = (!!form.getFieldValue().desconto ? parseFloat(form.getFieldValue().desconto) : 0)
                result = (!!tot > 0 ? (valor * 100) / tot : 0);
                form.setFieldsValue({ percdesc: result.toFixed(2) });
            } else {
                if (valor > tot) {
                    form.setFieldsValue({ desconto: tot });
                    form.setFieldsValue({ percdesc: 100 });
                } else {
                    result = (valor * 100) / tot;
                    form.setFieldsValue({ percdesc: result.toFixed(2) });
                }
            }
            calculaTotalItemDescAcr();
        }
    };

    async function buscarProduto(produto) {
        let listaItens = [...listaSelectProd];
        let prod = listaItens.filter((item) => item.key === produto)[0];
        let buscaOK = await popularProduto(prod.pro_id, false, prod.prg_id ? prod.prg_id : null);
        if (buscaOK) {
            await buscarDadosProdutoPedido(prod.pro_id);
        } else {
            cancelar();
        }
    };

    async function buscarDadosProdutoPedido(produto) {
        let prod = !!produto ? produto : form.getFieldValue().pro_id;
        let destinoOperacao = (!!dadosEndereco.est_sigla && !!dadosContribuinte.est_sigla && (dadosEndereco.est_sigla === dadosContribuinte.est_sigla) ? '1' : '2');
        let res = await api.get(`Produto/BuscarDadosProduto?IdProduto=${prod}&ufDestino=${!!dadosEndereco ? dadosEndereco.est_sigla : dadosContribuinte.est_sigla}`
            + `&operacaoCodigo=${form.getFieldValue().ope_id}&ufOrigem=${dadosContribuinte.est_sigla}&tipoContribuinte=${dadosContribuinte.loc_tipocontribuinte}`
            + `&empresaEnquadramento=${dadosContribuinte.emp_regimetributario}&destinoOperacao=${destinoOperacao}&indicadorPresenca=0`
        );
        if (res.status == 200) {
            let dados = res.data[0];
            dados.pro_id = prod;
            let filtros = !!produto ? `idProduto=${produto}` : '';
            filtros += !!dados.prg_id ? `&idProdutoGrade=${dados.prg_id}` : '';
            filtros += !!form.getFieldValue().ope_id ? `&idOperacaoFiscal=${form.getFieldValue().ope_id}` : '';
            filtros += !!form.getFieldValue().cli_id ? `&idCliente=${form.getFieldValue().cli_id}` : '';
            let listaPrecoTemp = (await api.get(`ListaPreco/ListaPrecoPadraoProduto?${filtros}`)).data;
            dados.ltp_id = listaPrecoTemp[0].ltp_id;
            let listaPrecoCliente = (await api.get(`ListaPrecoCliente/ListarListaPrecoCliente?${filtros}`)).data;
            if (!!listaPrecoCliente && listaPrecoCliente.length > 0) {
                let grade = !!dados.prg_id ? `&CodigoGrade=${dados.prg_id}` : ""; 
                let dadosPreco = await api.get(`ListaPrecoItem/BuscaPrecoItem?CodigoListaPreco=${listaPrecoCliente[0].ltp_id}&CodigoProduto=${produto}${grade}`);
                if (dadosPreco.data) {
                    form.setFieldsValue({
                        ltp_id: !!dadosPreco.ltp_id ? dados.ltp_id : listaPrecoCliente[0].ltp_id,
                        lpi_valorvenda: dadosPreco.data.lpi_valorvenda,
                        pdi_valorunitario: dadosPreco.data.lpi_valorvenda,
                        pdi_valortotal: form.getFieldValue().pdi_quantidade * dadosPreco.data.lpi_valorvenda,
                    });
                }
            } else {
                form.setFieldsValue({ ltp_id: (!!listaPrecoTemp[0].ltp_id ? listaPrecoTemp[0].ltp_id : '') });
            }
            setDadosProduto(dados);
            buscaPrecoListaPrecoSelecionada(dados);
        }
    };

    async function popularProduto(prod_id, editar = false, prg_id = null) {
        let dadosTemp = {};
        setExibirDetalhes(true);
        let listaprecoItem = null;
        let total = 0;
        let dados = manutencao.dados;
        let custoProd = isObjetoDiffVazio(custo) && !!custo.key ? "&custoTransferencia=" + custo.key : "";
        let produtoGrade = !!prg_id ? `&IdGrade=${prg_id}` : ((!!dados && dados[0].prg_id != null) ? `&IdGrade=${dados[0].prg_id}` : '');
        let produto = !!prod_id ? prod_id : (!!dados[0].pro_id ? dados[0].pro_id : "");
        let grade = !!prg_id ? `&CodigoGrade=${prg_id}` : ((!!dados && dados[0].prg_id != null)? `&CodigoGrade=${dados[0].prg_id}` : "");
        let filtros = `idProduto=${produto}`;
        filtros += !!prg_id ? `&idProdutoGrade=${prg_id}` : (!!dados ? `&idProdutoGrade=${dados[0].prg_id}` : "");
        filtros += !!form.getFieldValue().ope_id ? `&idOperacaoFiscal=${form.getFieldValue().ope_id}` : (!!dados[0].ope_id ? dados[0].ope_id : "");
        filtros += !!form.getFieldValue().cli_id ? `&idCliente=${form.getFieldValue().cli_id}` : (!!dados[0].cli_id ? dados[0].cli_id : "");
        let lpc = (await api.get(`ListaPrecoCliente/ListarListaPrecoCliente?${filtros}`)).data;
        if(lpc != null && lpc != 0 ){
            listaprecoItem = (await api.get(`ListaPrecoItem/BuscaPrecoItem?CodigoListaPreco=${lpc[0].ltp_id}&CodigoProduto=${produto}${grade}`)).data;
        }
        let res = await api.get(`Produto/BuscaProdutoPedido?IdProduto=${( !!prod_id ? prod_id : (!!dados[0].pro_id ? dados[0].pro_id : ""))}
        &ufDestino=${(!!dadosEndereco ? dadosEndereco.est_sigla : dadosContribuinte.est_sigla)}&ufOrigem=${dadosContribuinte.est_sigla}${custoProd}${produtoGrade}`);
       if(lpc != null && listaprecoItem != null ){
            form.setFieldsValue({ ltp_id: lpc[0].ltp_id, ltp_nome: lpc[0].ltp_nome});
            res.data[0].dpr_precovenda = listaprecoItem.lpi_valorvenda;
            res.data[0].lpi_valorvenda = listaprecoItem.lpi_valorvenda;
        }
        if (res.status === 200) {
            let valorUnitario = 0;
            if (isObjetoDiffVazio(custo)) {
                valorUnitario = res.data[0].dpr_precovenda;
            } else {
                valorUnitario = res.data[0].lpi_valorvenda > 0 ? res.data[0].lpi_valorvenda : res.data[0].dpr_precovenda;
            }
            if (!editar) {
                form.setFieldsValue({ pdi_quantidade: 1 });
                form.setFieldsValue({ pdi_valorunitario: valorUnitario });
                form.setFieldsValue({ pdi_valortotal: valorUnitario });
                form.setFieldsValue({ valorItemDesconto: valorUnitario });
            } else {
                valorUnitario = dados.pdi_valorunitario;
                total = valorUnitario * dados.pdi_quantidade;
                form.setFieldsValue({ pdi_quantidade: dados.pdi_quantidade });
                form.setFieldsValue({ pdi_valorunitario: valorUnitario });
                form.setFieldsValue({ pdi_valortotal: total });
                form.setFieldsValue({ valorItemDesconto: total - dados.pdi_valordesconto });
                form.setFieldsValue({ desconto: dados.pdi_valordesconto });
                form.setFieldsValue({ percdesc: dados.percdesc });
                //dispatch({ type: manutencaoActions.CHANGE, data: { dados: null } });
            }
            form.setFieldsValue({ prg_id: prg_id });
            dadosTemp.prg_id = prg_id;
            dadosTemp.pro_descricao = res.data[0].pro_descricao;
            dadosTemp.pro_codigo = res.data[0].pro_codigo;
            dadosTemp.pro_ean = res.data[0].pro_ean;
            dadosTemp.ncm_codigo = res.data[0].ncm_codigo;
            dadosTemp.ump_id = res.data[0].ump_id;
            dadosTemp.pro_id = res.data[0].pro_id;
            setDadosDetalhes(dadosTemp);
            return true;
        }
        else {
            console.log(res.data);
        }

    };

    function adicionarItem() {
        let dadosItens = [...dadosTabela.dadosItens];
        let lista = [...listaSelectProd];
        let dados = lista.filter(item => item.key === form.getFieldValue().pro_id)[0];
        if (parseFloat(form.getFieldValue().valorItemDesconto) === 0) {
            notification.warning({ description: 'Valor do item deve ser maior que zero!', message: 'Aviso' });
            return;
        }
        if (parseFloat(form.getFieldValue().pdi_quantidade) === 0) {
            notification.warning({ description: 'Quantidade de itens deve ser maior que zero!', message: 'Aviso' });
            return;
        }
        if (dados == null) {
            if (!!manutencao.dados?.editando) {
                let dadosEditando = lista[0];
                dados = dadosItens.filter((item) => item.pro_id === dadosEditando.pro_id && ((!!dadosEditando.prg_id && dadosEditando.prg_id === item.prg_id) || !dadosEditando.prg_id))[0];
            } else {
                dados = dadosItens.filter((item) => item.key === form.getFieldValue().pro_id)[0];
            }
        }
        if (dadosItens.find(campo => campo.pro_id === dados.pro_id
            && ((!!form.getFieldValue().prg_id && form.getFieldValue().prg_id === campo.prg_id) || !form.getFieldValue().prg_id))) {
            adicionarItemPedido(dados);
            let dadosEditando = dadosItens.filter((prod) => (prod.pro_id === dados.pro_id && (!!!dados.prg_id || dados.prg_id === prod.prg_id)))[0];
            let indice = dadosItens.findIndex((item) => (item === dadosEditando));
            dadosItens.splice(indice, 1, { ...dados });
            dadosTabela.setDadosItens(dadosItens);
        } else {
            adicionarItemPedido(dados);
            dadosItens.push(dados);
        }
        dadosTabela.setDadosItens(dadosItens);
        setDesabilitarProd_id(false);
        setDadosDetalhes({});
        setExibirDetalhes(false);
        setDesabilitarProd_id(false);
        limparCampos();
    };

    function adicionarItemCodBarras() {
        let listaItens = [...dadosTabela.dadosItens];
        let codigoProduto = form.getFieldValue().pro_codigo;
        let dados = listaItens.find((item) => item.pro_ean == codigoProduto);
        if (!!dados) {
            dados.pdi_quantidade += 1;
            let valorTotal = dados.pdi_quantidade * dados.pdi_valorunitario;
            let valorDesc = valorTotal * (dados.percdesc / 100);
            dados.valorItemDesconto = valorTotal - valorDesc;
        } else {
            dados = produtoBuscaEan;
            adicionarItemPedido(dados);
            dados.descricaograde = produtoBuscaEan.descricaograde
            listaItens.push(dados);
            dadosTabela.setDadosItens(listaItens)
        }
        cancelar();
    };

    function cancelar() {
        setExibirDetalhes(false);
        setDadosDetalhes({});
        setDesabilitarProd_id(false);
        limparCampos();
    };

    function limparCampos() {
        form.setFieldsValue({ pro_id: null, pro_codigo: null, percdesc: 0, desconto: 0, percacresc: 0, acrescimo: 0, icm_id: null });
    };


    function adicionarItemPedido(dados) {
        dados.pdi_quantidade = parseFloat(!!form.getFieldValue().pdi_quantidade ? form.getFieldValue().pdi_quantidade : dadosDetalhes.pdi_quantidade);
        dados.pdi_valorunitario = parseFloat(form.getFieldValue().pdi_valorunitario);
        dados.percdesc = parseFloat(!!form.getFieldValue().percdesc ? form.getFieldValue().percdesc : 0);
        dados.pdi_valordesconto = parseFloat(form.getFieldValue().desconto);
        dados.valorItemDesconto = parseFloat(form.getFieldValue().valorItemDesconto);
        dados.pdi_valortotal = parseFloat(form.getFieldValue().pdi_valortotal);
        dados.pro_codigo = !!dadosDetalhes.pro_codigo ? dadosDetalhes.pro_codigo : dados.pro_codigo;
        dados.pro_id = !!dadosDetalhes.pro_id ? dadosDetalhes.pro_id : dados.pro_id;
        dados.pro_descricao = dadosDetalhes.pro_descricao;
        dados.pro_ean = dadosDetalhes.pro_ean;
        dados.prg_id = dadosDetalhes.prg_id;
        dados.pdi_basecalculoicms = 0;
        dados.pdi_basecalculoicmsst = 0;
        dados.pdi_basecalculoipi = 0;
        dados.pdi_percentualicms = 0;
        dados.pdi_percentualicmsst = 0;
        dados.pdi_percentualipi = 0;
        dados.ope_id = !!dadosDetalhes.ope_id ? dadosDetalhes.ope_id : (!!dados.ope_id ? dados.ope_id : '');
        dadosTabela.setDadosItens(dados);
    };

    async function buscarProdutoCodBarra(campo) {
        let dados = await api.get(`Produto/ListaProdutoCodigo?filtro=${campo.target.value.trim()}`);
        if (dados.data?.length > 1) {
            setListaDadosProdModal(dados.data);
            setAbrirModalListaProd(true);
        } else {
            buscarDadosProdutoPedido(dados.data[0].pro_id);
            form.setFieldsValue({ pro_id: dados.data[0].pro_id });
            let retOk = await popularProduto(dados.data[0].pro_id, false, dados.data[0].prg_id);
            if (retOk) {
                setProdutoBuscaEan(dados.data[0]);
                setLiberadoParaIncluir(true);
            } else {
                cancelar();
            }
        }
    };

    async function buscaPrecoListaPrecoSelecionada(dados) {
        let proId = !!dadosProduto.pro_id ? dadosProduto.pro_id : (!!dados.pro_id ? dados.pro_id : "");
        let prg = !!!dadosProduto.prg_id ? dadosProduto.prg_id : (!!!dados.prg_id ? dados.prg_id : "");
        let filtros = `&CodigoProduto=${proId}`;
        filtros += !!prg ? `&CodigoGrade=${prg}` : "" ;
        let listaPreco = !!form.getFieldValue().ltp_id ? form.getFieldValue().ltp_id : (dados.ltp_id ? dados.ltp_id : "");
        let dadosPreco = await api.get(`ListaPrecoItem/BuscaPrecoItem?CodigoListaPreco=${listaPreco}${filtros}`);
        if (dadosPreco.data) {
            form.setFieldsValue({
                pdi_valorunitario: dadosPreco.data.lpi_valorvenda,
                pdi_valortotal: form.getFieldValue().pdi_quantidade * dadosPreco.data.lpi_valorvenda,
            });
            alterarValorTotal();
        } else {
            notification.warning({ description: 'Item não encontrado na lista de preço selecionada!', message: 'Aviso' });
        }
    }

    return (
        <div>
            <div>
                <Row gutter={[8, 16]}>
                    {!!consultaProduto === false &&
                        <Col xs={22} sm={22} md={22} lg={22} xl={23} xxl={23}>
                            <Form.Item label="Selecione o Produto" name="pro_id">
                                <SelectProduto selecionarRegUnico="key" disabled={desabilitarProd_id} valueKey={true} detalhes={true} 
                                placeholder="Selecione o Produto" name="pro_id" form={form} 
                                onChange={(dados) => { buscarProduto(dados) }} ordem={"pro_id"} setListaDados={setListaSelectProd}/>
                            </Form.Item>
                        </Col>
                    }
                    {!!consultaProduto &&
                        <Col xs={22} sm={22} md={22} lg={22} xl={23} xxl={23}>
                            <Form.Item label="Localize o Produto" name="pro_codigo">
                                <Input onPressEnter={(value) => {
                                    buscarProdutoCodBarra(value)
                                }} placeholder="Informe o Produto/Mercadoria" />
                            </Form.Item>
                        </Col>
                    }
                    <Col xs={2} sm={2} md={2} lg={2} xl={1} xxl={1} className="i-button">
                        <Tooltip title={!!consultaProduto ? 'Localize produto por EAN' : 'Selecione o produto'} placement="left">
                            <Button onClick={togglePesquisa} block>
                                {consultaProduto ? <SearchOutlined /> : <BarcodeOutlined />}
                            </Button>
                        </Tooltip>
                    </Col>
                </Row>
            </div>
            {exibirDetalhes &&
                <div className="m-t-16">
                    <Card extra={
                        <Row align="middle">
                            <Col span={24}>
                                <Descriptions size="small">
                                    <Descriptions.Item label="Produto">
                                        <b>{dadosDetalhes.pro_descricao}</b>
                                    </Descriptions.Item>
                                </Descriptions>
                            </Col>
                            <Col span={24}>
                                <Descriptions column={{ xxl: 3, xl: 3, lg: 2, md: 1, sm: 1, xs: 1 }} size="small">
                                    <Descriptions.Item label="Código Interno">
                                        <b>{dadosDetalhes.pro_codigo}</b>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="Código de Barras">
                                        <b>{dadosDetalhes.pro_ean}</b>
                                    </Descriptions.Item>
                                    <Descriptions.Item label="NCM">
                                        <b>{dadosDetalhes.ncm_codigo}</b>
                                    </Descriptions.Item>
                                </Descriptions>
                            </Col>
                        </Row>
                    }>
                        <Row gutter={[8, 0]}>
                            <Form.Item hidden label="Id da Grade do Produto" name="prg_id">
                                <Input></Input>
                            </Form.Item>
                            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                <Form.Item label="Lista Preço" name="ltp_id">
                                    <SelectPaginacao url="ListaPreco/ListarListaPreco" placeholder="Selecione a Lista" form={form} nameLabel="ltp_nome" nameValue="ltp_id" 
                                    onChangeFunction={(valor) => buscaPrecoListaPrecoSelecionada(valor.ltp_id)} conteudo={
                                        lp => (<Select.Option value={lp.ltp_id} key={lp.key}>{lp.ltp_id} - {lp.ltp_nome}</Select.Option>)
                                    } />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={3} lg={3} xl={3}>
                                <Form.Item label="Quantidade" name="pdi_quantidade">
                                    <InputNumber decimalSeparator="," placeholder="Informe a Quantidade do Produto" onChange={() => { alterarValorTotal() }} />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={3} lg={3} xl={3}>
                                <InputPreco label="Valor Unitário (R$)" name="pdi_valorunitario" form={form}  onChange={() => { alterarValorTotal() }} />
                            </Col>
                            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                                <InputPreco label="Valor Total do Item (R$)" name="pdi_valortotal" form={form} disabled={true} />
                            </Col>
                            {!isObjetoDiffVazio(custo) && <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                                <InputPercentual name="percdesc"
                                    label="Desconto (%)"
                                    max={100}
                                    min={0}
                                    onBlur={() => (calculaDesconto('PERC'))}
                                />
                            </Col>}
                            {!isObjetoDiffVazio(custo) && <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                                <InputPreco label="Valor do Desconto (R$)" name="desconto" precision={2} onChange={() => (calculaDesconto('VALOR'))} />
                            </Col>}
                            {!isObjetoDiffVazio(custo) && <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                                <InputPreco label="VALOR TOTAL (R$)" name="valorItemDesconto" disabled={true} />
                            </Col>}
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="m-t-8" justify="end">
                                <Row gutter={[8, 8]} justify="end">
                                    <Col xs={24} sm={4} md={4} lg={4} xl={4} justify="end">
                                        <Button icon={<CloseOutlined />} onClick={() => (cancelar())} block>
                                            Cancelar
                                        </Button>
                                    </Col>
                                    <Col xs={24} sm={4} md={4} lg={4} xl={4} justify="end">
                                        <Button icon={<PlusOutlined />} type="primary" onClick={() => (adicionarItem())} block>
                                            Adicionar
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card>
                </div>}
            <ModalManutencaoNota formulario={form} exibirModal={abrirModalManutencaoNota} fecharModal={() => { cancelar(); setAbrirModalManutencaoNota(false); }} dadosContribuinte={dadosContribuinte} dadosOperacao={dadosOperacao} dadosEndereco={dadosEndereco} dadosProduto={dadosProduto} />
            <ModalListaProduto exibirModalListaProduto={abrirModalListaProd} fecharModalListaProduto={() => { setAbrirModalListaProd(false); }} dadosItens={listaDadosProdModal} />
        </div >
    );

}